import axios from 'axios';
import { paymentBaseUrl } from '../../util/constants';

export default async function confirmCard(extId: string): Promise<any> {
  const {
    data,
  } = await axios.post(`${paymentBaseUrl}/ConfirmStoreCard?extId=${extId}`);
  return data;
}
